import appCustomTextConst from "@/pages/application/const/applicationCustomTextConst";
import { ehSchoolsData, middletonSchools, preSchoolsDropdown, schools } from "@/pages/application/data";
import assets from "@/assets/assets";

const apfConfig = {
	"Claymore": {
		introduction: "Welcome to the student application form for EtonHouse schools. If you are here, it is very likely that you have made the decision to join one of our wonderful schools. Congratulations on choosing what we know will be a wonderful learning experience for your child. We will guide you through this journey and make the application process as smooth as possible. To complete the application form, you will need to upload some supporting documents and proof of payment for the registration fee $2,834 (incl 9% GST) to be paid via PayNow or wire transfer.",
		showDropdown: false,
		apfDeclarationAgreement: "PRE",
		apfDocumentChecklist: "CLAY",
		apfDocumentChecklistCustomDoc: "https://kws.etonhouse.com/images/clay_tc.pdf"
	},
	"EH": {
		introduction: `Welcome to the student application form for EtonHouse schools. If you are here, it is very likely that you have made the decision to join one of our wonderful schools. Congratulations on choosing what we know will be a wonderful learning experience for your child. We will guide you through this journey and make the application process as smooth as possible. To complete the application form, you will need to upload some supporting documents and proof of payment for the application fee of $654 (includes 9% GST) to be paid via PayNow or wire transfer.`,
		showDropdown: true,
		apfDeclarationAgreement: "EH",
		apfDocumentChecklist: "EH",
		schoolIcon:assets.application.EHIS
	},
	"apfLanguageTemplate": {
		"Broadrick": [schools.Broadrick],
		"Orchard": [schools.Orchard]
	},
	"declarationContent": {
		"Broadrick": "(Please note that all students studying at EtonHouse International School are required by the SkillsFuture Singapore (SSG) to sign a Standard PEI-Student Contract. It is important that you understand the above declaration on late commencement prior to signing a Standard PEI-Student Contract.)",
		"Default": "(Please note that all students studying at EtonHouse International School are required by the SkillsFuture Singapore (SSG) to sign a Standard Student Contract. It is important that you understand the declaration below on late commencement prior to signing a Standard Student Contract.)"
	},
	"PRE": {
		introduction: `Welcome to the student application form for EtonHouse schools. If you are here, it is very likely that you have made the decision to join one of our wonderful schools. Congratulations on choosing what we know will be a wonderful learning experience for your child. We will guide you through this journey and make the application process as smooth as possible. To complete the application form, you will need to upload some supporting documents and proof of payment for the registration fee to be paid via PayNow or wire transfer.`,
		schools: preSchoolsDropdown
	},
	"MIS": {
		schools: middletonSchools,
		schoolIcon: assets.application.MIS
	},
	"default": {
		schools: schools
	},
	"schoolBusServiceText":{
		"Broadrick": [schools.Broadrick, ehSchoolsData?.Claymore?.schoolID],
		"Orchard": [schools.Orchard],
		"Sentosa": [schools["Sentosa Primary"]],
	},
	preSteps : [
		{ title: "Step 1", desc: "Student Details" },
		{ title: "Step 2", desc: "Parent(s) Details" },
		{ title: "Step 3", desc: "Supporting Infomation" },
		{ title: "Step 4", desc: "Declaration and Agreement" },
		{ title: "Step 5", desc: "Attachment" },
		{ title: "Step 6", desc: "Others" }
	],
	excludeAdditionQuestion:["PRE","CLAY"]
};

export default apfConfig;